import React from 'react'
import { Link } from 'react-router-dom'

function Card({data}) {
  return (
    <div className='card'>
        {data.map((item)=>{
            return <div>
                <h2>
                    <Link to={`/${item.name}`}>{item.name}</Link>
                </h2>
            </div>
        })}
    </div>
  )
}

export default Card